/**
 * Check adherence ID for annexes
 */
import { Global_ISDA_Functions } from 'Root/global/global';

(function( $ ) {
		'use strict';
		let globalIsdaFunctions = new Global_ISDA_Functions();

		//fire funcs when ready
		ready( deleteAdhPostEvent );

		/**
		 * Detect if doc is ready and fire func inside
		 *
		 * @param fn
		 */
		function ready( fn ) {
			if ( document.attachEvent
					? document.readyState === 'complete'
					: document.readyState !== 'loading' ) {
				fn();
			} else {
				document.addEventListener( 'DOMContentLoaded', fn );
			}
		}

		/**
		 * Click event for deleting adherence post
		 */
		function deleteAdhPostEvent() {
			var btnRefNumberCheck = document.getElementById( 'btn-check-adherence-id' );

			if ( btnRefNumberCheck === null ) {
				return;
			}

			btnRefNumberCheck.addEventListener( 'click', function( e ) {
				e.preventDefault();
				let adherenceIdVal = document.getElementById( 'adherence-id' ).value;

				if ( adherenceIdVal === null ) {
					return;
				}

				validateAdherenceId( adherenceIdVal );
			} );

		}

		//@todo: Add nonce
		function validateAdherenceId( adherenceId ) {
			$.ajax( {
				        type   : 'POST',
				        url    : wpApiSettings.root + 'isda/v1/adherence-id-find-master-adh',
				        data   : {
					        manual_adherence_id: adherenceId
				        },
				        success: function( data ) {
					        updateMasterDropdown( data );
				        },
				        error  : function( data ) {
					        updateMasterMessage( 'error', data.responseJSON[ 'error' ] );
				        }
			        } );
		}

		function updateMasterMessage( status, messageText ) {
			let messageWrapper = document.getElementById( 'adherence-id-validation' );

			if ( status === 'success' ) {
				messageWrapper.textContent = messageText;
				globalIsdaFunctions.vanillaRemoveClass( messageWrapper, 'alert-danger' );
				globalIsdaFunctions.vanillaRemoveClass( messageWrapper, 'alert-warning' );
				globalIsdaFunctions.vanillaRemoveClass( messageWrapper, 'hidden' );
				globalIsdaFunctions.vanillaAddClass( messageWrapper, 'alert-success' );
			} else if ( status === 'exists' ) {
				messageWrapper.textContent = messageText;
				globalIsdaFunctions.vanillaRemoveClass( messageWrapper, 'alert-danger' );
				globalIsdaFunctions.vanillaRemoveClass( messageWrapper, 'alert-success' );
				globalIsdaFunctions.vanillaRemoveClass( messageWrapper, 'hidden' );
				globalIsdaFunctions.vanillaAddClass( messageWrapper, 'alert-warning' );
			} else {
				messageWrapper.textContent = messageText;
				globalIsdaFunctions.vanillaRemoveClass( messageWrapper, 'alert-warning' );
				globalIsdaFunctions.vanillaRemoveClass( messageWrapper, 'alert-success' );
				globalIsdaFunctions.vanillaRemoveClass( messageWrapper, 'hidden' );
				globalIsdaFunctions.vanillaAddClass( messageWrapper, 'alert-danger' );
			}
		}

		function updateMasterDropdown( data ) {
			let dropdown        = document.getElementById( 'selected-master' ),
			    dropdownOptions = dropdown.options,
			    newOption       = document.createElement( 'option' );

			let existingValues = [];

			Object.keys( dropdownOptions ).map( function( value, key ) {
				if ( dropdownOptions[ key ] !== null && dropdownOptions[ key ] !== undefined ) {
					existingValues.push( dropdownOptions[ key ].value );
				}
			} );

			newOption.value = data.adh_isda_id;
			newOption.text = data.title + ' (' + data.date + ')';

			//check if adherence id already exists, and if so, don't add to dropdown
			if ( existingValues.includes( data.adh_isda_id ) ) {
				updateMasterMessage( 'exists', data.exists );
				return;
			}

			//adherence id does not exist in dropdown so add it
			dropdown.add( newOption, null );
			updateMasterMessage( 'success', data.success );
		}

	}
)( jQuery );